// Rejects if `promise` has not settled within `timeoutMs`. Needed because a
// Firebase read on a dropped connection never rejects - the SDK just queues it
// until connectivity returns - so a .catch() alone cannot notice it (issue #5).
export function withTimeout(promise, timeoutMs, timeoutMessage) {
  let timeoutId;
  const timeout = new Promise((_, reject) => {
    timeoutId = setTimeout(
      () => reject(new Error(timeoutMessage || "Timed out")),
      timeoutMs
    );
  });
  return Promise.race([promise, timeout]).finally(() =>
    clearTimeout(timeoutId)
  );
}
